import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Overlay from '../Overlay/Overlay';
import { motion } from 'framer-motion';
import cx from 'classnames';
import './drawer.scss';

class Drawer extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.element,
      PropTypes.func,
    ]).isRequired,
    onDismiss: PropTypes.func,
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node,
      PropTypes.element,
      PropTypes.func,
    ]).isRequired,
    name: PropTypes.string,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    className: PropTypes.string,
  };

  static defaultProps = {
    size: 'medium',
  };

  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind();
  }

  handleClick = () => {
    if (this.props.onDismiss) {
      this.props.onDismiss();
    }
  };

  render() {
    return (
      <Overlay onDismiss={this.handleClick} bgColor="rgba(0, 0, 0, .6)">
        <motion.div
          initial={{ opacity: 0, right: '-200px' }}
          animate={{ opacity: 1, right: '0px' }}
          exit={{ opacity: 0, right: '-100px' }}
          transition={{
            ease: [0.19, 1, 0.22, 1],
            duration: 0.3,
          }}
          positionTransition
          className={cx(
            'drawer fixed bg-white shadow-lg',
            this.props.className,
            {
              [this.props.name]: Boolean(this.props.name),
              'max-w-sm': this.props.size === 'small',
              'max-w-md': this.props.size === 'medium',
              'max-w-lg': this.props.size === 'large',
            }
          )}>
          <div className="drawer__header flex items-center justify-between p-4">
            <button
              onClick={this.handleClick}
              className="cursor-pointer bg-transparent border-0 p-0">
              <svg>
                <path d="M19.6 5.5l-1-1.1-6.6 6.5-6.5-6.5-1.1 1 6.5 6.6-6.5 6.5 1 1.1 6.6-6.5 6.5 6.5 1.1-1-6.5-6.6 6.5-6.5z" />
              </svg>
            </button>
            {this.props.title}
          </div>
          <div className="drawer__content p-4">{this.props.children}</div>
          {this.props.footer && (
            <div className="drawer__footer">{this.props.footer}</div>
          )}
        </motion.div>
      </Overlay>
    );
  }
}

export default  Drawer;
